import React, { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import { CONFETTI_LOGO_INTERVAL_MS } from '../../config/decoracion';
import './LogoMundial.css';

// Paleta celeste y blanco (bandera argentina)
const COLORS = ['#75AADB', '#4A90D9', '#A8D0EF', '#FFFFFF', '#FFFFFF'];

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Pelotita posada sobre el logo + ráfagas periódicas de confetti que salen
// desde la posición real del logo (calculada al momento de disparar).
const LogoMundial = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (prefersReduced) return undefined;

    const fire = () => {
      const el = ref.current;
      if (!el || document.hidden) return; // no dispara si la pestaña no está visible
      const r = el.getBoundingClientRect();
      if (!r.width) return;
      const x = (r.left + r.width / 2) / window.innerWidth;
      const y = (r.top + r.height / 2) / window.innerHeight;
      confetti({
        particleCount: 70,
        spread: 75,
        startVelocity: 38,
        gravity: 0.9,
        origin: { x, y },
        colors: COLORS,
        zIndex: 99999,
        disableForReducedMotion: true,
      });
    };

    // Primer disparo unos segundos después de cargar (cuando ya pasó el splash)
    const first = setTimeout(fire, 4500);
    const id = setInterval(fire, CONFETTI_LOGO_INTERVAL_MS);
    return () => {
      clearTimeout(first);
      clearInterval(id);
    };
  }, []);

  return (
    <span className="logo-ball" ref={ref} aria-hidden="true">
      <img src={`${process.env.PUBLIC_URL}/img/pelota.png`} alt="" />
    </span>
  );
};

export default LogoMundial;
